import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function MainImg({ img, alt = '' }: any) {
    const { useState, useRouter, Link, useLang, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('customize_bundle_for_shp2');

    return (
        <div className={`customize-bundle-main-img ${css['customize-bundle-main-img']}`}>
            <div className="menu-title-box">
                <Link
                    className="back-to-bundle"
                    href={'/smart-home-panel-2?tab=bundles'}
                    dataLayer={{
                        event: 'uaEvent',
                        event_name: 'back_to_previous',
                        position: t('product_title'),
                        button_name: t('product_title'),
                        type: 'Back',
                    }}
                    target="_self"
                >
                    <svg className="link-back-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M7.30859 1.76953L3.30859 5.76953L7.30859 9.76953" stroke="#3F68E0" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <span className="link-back-text">{t('back')}</span>
                </Link>
                <h4 className="product-title">{t('product_title')}</h4>
            </div>
            <div className="img-outer-box">
                <div className="img-box">
                    <EFPicture src={img} alt={alt || 'EcoFlow Smart Home Panel 2'} />
                </div>
            </div>
        </div>
    );
}
